import React, { useState } from "react";

export default function AsciiFunLab() {
  const [textInput, setTextInput] = useState("");
  const [asciiInput, setAsciiInput] = useState("");
  const [asciiOutput, setAsciiOutput] = useState("");
  const [textOutput, setTextOutput] = useState("");
  const [tableOpen, setTableOpen] = useState(false);
  const [message, setMessage] = useState("");

  const asciiTable = [
    ["A", 65, "a", 97],
    ["B", 66, "b", 98],
    ["C", 67, "c", 99],
    ["D", 68, "d", 100],
    ["E", 69, "e", 101],
    ["F", 70, "f", 102],
    ["G", 71, "g", 103],
    ["H", 72, "h", 104],
    ["I", 73, "i", 105],
    ["J", 74, "j", 106],
    ["K", 75, "k", 107],
    ["L", 76, "l", 108],
    ["M", 77, "m", 109],
    ["N", 78, "n", 110],
    ["O", 79, "o", 111],
    ["P", 80, "p", 112],
    ["Q", 81, "q", 113],
    ["R", 82, "r", 114],
    ["S", 83, "s", 115],
    ["T", 84, "t", 116],
    ["U", 85, "u", 117],
    ["V", 86, "v", 118],
    ["W", 87, "w", 119],
    ["X", 88, "x", 120],
    ["Y", 89, "y", 121],
    ["Z", 90, "z", 122],
  ];

  const translate = () => {
  if (textInput) {
    let result = "";
    for (let i = 0; i < textInput.length; i++) {
      result += textInput.charCodeAt(i) + " ";
    }
    result = result.trim();
    setAsciiOutput(result);
    setTextOutput("");

    // Correctness check
    if (asciiInput.trim() === result) {
      setMessage("✅ Correct Answer");
    } else if (asciiInput.trim() !== "") {
      setMessage("❌ Incorrect Answer");
    } else {
      setMessage(""); // no ASCII input provided
    }

  } else if (asciiInput) {
    let chars = "";
    asciiInput.split(" ").forEach((num) => {
      if (!isNaN(num) && num !== "") chars += String.fromCharCode(num);
    });
    setTextOutput(chars);
    setAsciiOutput("");

    // Correctness check
    if (textInput === chars) {
      setMessage("✅ Correct Answer");
    } else if (textInput !== "") {
      setMessage("❌ Incorrect Answer");
    } else {
      setMessage(""); // no text input provided
    }

  } else {
    alert("Please enter text or ASCII numbers!");
  }
};


  const clearBoxes = () => {
    setTextInput("");
    setAsciiInput("");
    setAsciiOutput("");
    setTextOutput("");
    setMessage("");
  };

  return (
    <div
      style={{
        fontFamily: "'Comic Sans MS', cursive, sans-serif",
        background: "linear-gradient(135deg, #a2d2ff, #cdb4db)",
        color: "#333",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#4a4e69", fontSize: "2.5em", marginBottom: "20px" }}>
        🤖 ASCII Fun Lab 🎉
      </h1>

      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "20px" }}>
        {/* CENTER BOX */}
        <div
          style={{
            background: "#fff",
            borderRadius: "20px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            padding: "20px",
            maxWidth: "400px",
            flex: 1,
            textAlign: "center",
          }}
        >
          <h2>ASCII Converter</h2>
          <input
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
            placeholder="Type your text"
            style={{
              width: "90%",
              padding: "10px",
              margin: "5px 0",
              fontSize: "1em",
              borderRadius: "10px",
              border: "2px solid #4a4e69",
            }}
          />
          <input
            value={asciiInput}
            onChange={(e) => setAsciiInput(e.target.value)}
            placeholder="Type ASCII numbers (e.g., 72 101)"
            style={{
              width: "90%",
              padding: "10px",
              margin: "5px 0",
              fontSize: "1em",
              borderRadius: "10px",
              border: "2px solid #4a4e69",
            }}
          />
          <div>
            <button
              onClick={translate}
              style={{
                padding: "10px 20px",
                margin: "5px",
                fontSize: "1em",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#ffafcc",
                cursor: "pointer",
                transition: "0.3s",
              }}
            >
              OK
            </button>
            <button
              onClick={clearBoxes}
              style={{
                padding: "10px 20px",
                margin: "5px",
                fontSize: "1em",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#ffafcc",
                cursor: "pointer",
                transition: "0.3s",
              }}
            >
              Clear
            </button>
          </div>
          {asciiOutput && <div style={{ fontWeight: "bold", marginTop: "10px" }}>ASCII: {asciiOutput}</div>}
          {textOutput && <div style={{ fontWeight: "bold", marginTop: "10px" }}>Text: {textOutput}</div>}
          {message && <div style={{ fontWeight: "bold", color: "green", marginTop: "10px" }}>{message}</div>}
        </div>

        {/* ASCII TABLE */}
        <div
          style={{
            background: "#fff",
            borderRadius: "20px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            padding: "20px",
            maxWidth: "300px",
            flex: 1,
            textAlign: "center",
          }}
        >
          <h3
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => setTableOpen(!tableOpen)}
          >
            {tableOpen ? "▼" : "►"} ASCII Table
          </h3>
          {tableOpen && (
            <div style={{ overflowX: "auto", marginTop: "10px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9em" }}>
                <thead>
                  <tr style={{ backgroundColor: "#bde0fe" }}>
                    <th>Letter</th>
                    <th>ASCII</th>
                    <th>Letter</th>
                    <th>ASCII</th>
                  </tr>
                </thead>
                <tbody>
                  {asciiTable.map(([l1, a1, l2, a2], idx) => (
                    <tr key={idx}>
                      <td style={{ border: "1px solid #ccc", padding: "5px 8px" }}>{l1}</td>
                      <td style={{ border: "1px solid #ccc", padding: "5px 8px" }}>{a1}</td>
                      <td style={{ border: "1px solid #ccc", padding: "5px 8px" }}>{l2}</td>
                      <td style={{ border: "1px solid #ccc", padding: "5px 8px" }}>{a2}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
